import type { NikolaMessagePart } from "@chessla/shared";
import { parseBoardMarkers } from "../board/parse-board-markers";
import type { SendMessageResult } from "./chat.api";
import { completeNikolaActivityParts } from "./chat-message-parts";
import type { ChatStoreMessage } from "./chat.store";

const GAME_ID = /[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/gi;

export const chatResponseMessage = (result: SendMessageResult): ChatStoreMessage => {
  const parsed = parseBoardMarkers(result.reply);
  return {
    role: "assistant",
    content: result.reply,
    parts: result.parts,
    segments: parsed.segments,
    warnings: parsed.warnings.length ? parsed.warnings : undefined,
    boards: parsed.boards.length ? parsed.boards : undefined,
    pendingAction: result.pendingAction ?? null,
    creditsCharged: result.creditsCharged,
  };
};

export const chatResponseMessageWithProgress = (
  result: SendMessageResult,
  progress: readonly NikolaMessagePart[],
): ChatStoreMessage => {
  const message = chatResponseMessage(result);
  return {
    ...message,
    parts: [...completeNikolaActivityParts(progress), ...(message.parts ?? [])],
  };
};

export const sessionTitle = (topic: string | null, game: { opponent: string } | null): string => {
  const containedId = GAME_ID.test(topic ?? "");
  GAME_ID.lastIndex = 0;
  if (game && (containedId || !topic?.trim())) return `Your game against ${game.opponent}`;
  if (containedId) return "Game conversation";
  const title = topic?.trim();
  if (title) return title;
  return game ? `Your game against ${game.opponent}` : "Untitled conversation";
};
